import { FilterDropDownButton } from "@portal/BaseComponents/Filters/FilterDropdown/FilterDropDownButton";
import { FilterStrip } from "@portal/BaseComponents/Filters/Strip/FilterStrip";
import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { MenuClick } from "@portal/BaseComponents/Menu/type";
import { paymentFiltersAtom } from "@portal/store/Filters/payments/payments-filter";
import { paymentDefaultKeys } from "@portal/store/Filters/payments/predicate";
import { PaymentDefaultKeys } from "@portal/store/Filters/payments/type";
import produce from "immer";
import { useAtom } from "jotai";
import { PaymentDateFilter } from "./PaymentDate/PaymentDate";
import { PaymentModeFilter } from "./PaymentMode/PaymentMode";
import { PaymentStatusFilter } from "./PaymentStatus/PaymentStatusFilter";

function PaymentFilters() {
  const [paymentFilters, setPaymentsFilters] = useAtom(paymentFiltersAtom);

  function handleClick(info: MenuClick["0"]) {
    if (paymentDefaultKeys.includes(info.key as PaymentDefaultKeys)) {
      setPaymentsFilters((filter) => {
        return produce(filter, (draft) => {
          draft.activeFilterKeys.push(info.key as PaymentDefaultKeys);
        });
      });
    }
  }
  return (
    <FilterStrip>
      <Flex align="center" space={"12"}>
        <PaymentDateFilter />
        <PaymentModeFilter />
        <PaymentStatusFilter />
        <FilterDropDownButton
          items={paymentFilters.filterGroup}
          handleClick={handleClick}
          selectedValues={paymentFilters.activeFilterKeys}
          key={paymentFilters.activeFilterKeys.length}
        />
      </Flex>
    </FilterStrip>
  );
}

export { PaymentFilters };
